export const TData = [
    {
        "id": 1,
        "uid": "a943e833-6ed3-4c4f-8be2-ca4a37efc14b",
        "code": "bottega_veneta",
        "label": "Bottega Veneta",
        "image": "https://metahuman.interlogica.ai/static/media/bottega-veneta.jpg",
        "voice": 1
    },
    {
        "id": 3,
        "uid": "a84e7330-cd0e-4d5c-998d-ae4fe1260a3a",
        "code": "plain",
        "label": "Generic",
        "image": "https://metahuman.interlogica.ai/static/media/generic.jpg",
        "voice": 1
    },
    {
        "id": 5,
        "uid": "ac0d2f22-ba53-4135-837c-958f3b1de723",
        "code": "banca_ifis",
        "label": "Banca Ifis",
        "image": "https://metahuman.interlogica.ai/static/media/ifis.jpg",
        "voice": 1
    },
    {
        "id": 8,
        "uid": "5046db19-fd80-42c4-a1fd-dc50af18bfb0",
        "code": "alpinestars",
        "label": "Alpinestars",
        "image": "https://metahuman.interlogica.ai/static/media/alpinestars.jpg",
        "voice": 2
    },
    {
        "id": 9,
        "uid": "c3c7cbc7-1afd-411c-a91a-318cfc1e3600",
        "code": "tecnica_group",
        "label": "Tecnica Group",
        "image": "https://metahuman.interlogica.ai/static/media/tecnica.jpg",
        "voice": 1
    },

    {
        "id": 11,
        "uid": "5cb74eef-2194-46b3-8497-207aa0458d9c",
        "code": "horizon",
        "label": "Horizon",
        "image": "https://metahuman.interlogica.ai/static/media/horizon.jpg",
        "voice": 1
    },
    {
        "id": 12,
        "uid": "bf428afd-a10e-4be1-ae34-78123e8ffa9a",
        "code": "stevanato",
        "label": "Stevanato Group",
        "image": "https://metahuman.interlogica.ai/static/media/stevanato.jpg",
        "voice": 1
    },
    {
        "id": 13,
        "uid": "44a2c8dc-1212-4ab9-84c4-c95fb7c6a91e",
        "code": "people",
        "label": "People",
        "image": "",
        "voice": 1
    }


];